// Image-based sticker/coozie pickers for the cart drawer add-on tiles
// (snippets/cart_drawer_addons.liquid).
//
// This lives in its own asset file, loaded unconditionally from
// snippets/cart-drawer.liquid, rather than as an inline <script> inside
// the addons snippet itself. That snippet only renders once the cart has
// items, so on a fresh session its very first appearance often comes from
// an AJAX cart-drawer re-render (cart.js / product-form.js replacing
// drawer HTML via `.innerHTML =`) rather than a real page load — and
// per the HTML spec, <script> tags inserted via innerHTML never execute.
// An inline script in that snippet would silently never run, leaving the
// pickers dead: no random default images, no click handling at all. This
// file loads once on every real page load instead, and relies on
// document-level event delegation plus a MutationObserver so it keeps
// working no matter how or when the addons markup itself shows up later.
(function () {
  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function selectOption(dropdown, option) {
    dropdown.dataset.value = option.dataset.value;
    var thumb = dropdown.querySelector('[data-img-thumb]');
    thumb.src = option.dataset.image;
    thumb.alt = option.dataset.value;
    dropdown.querySelectorAll('.img_dropdown__option').forEach(function (o) {
      o.classList.toggle('is-selected', o === option);
    });
    // Keep the accessible name in sync with the visual-only picker so
    // screen reader users still hear which option is currently chosen.
    var toggle = dropdown.querySelector('[data-img-toggle]');
    if (!toggle.dataset.baseLabel) toggle.dataset.baseLabel = toggle.getAttribute('aria-label') || '';
    toggle.setAttribute('aria-label', toggle.dataset.baseLabel + ': ' + option.dataset.value + ' selected');
  }

  // Pre-fill each dropdown with a random valid image so "Add to cart"
  // works immediately if the shopper doesn't bother changing anything.
  // Gameday Bundle's 3 sticker dropdowns avoid repeating a design.
  function initGamedayPicker(picker) {
    var dropdowns = Array.prototype.slice.call(
      picker.querySelectorAll('[data-prop-name^="Sticker"]')
    );
    var chosen = [];
    dropdowns.forEach(function (dropdown) {
      var options = Array.prototype.slice.call(dropdown.querySelectorAll('.img_dropdown__option'));
      var remaining = options.filter(function (o) { return chosen.indexOf(o.dataset.value) === -1; });
      var option = pick(remaining);
      chosen.push(option.dataset.value);
      selectOption(dropdown, option);
    });
    var coozieDropdown = picker.querySelector('[data-prop-name="Coozie"]');
    var coozieOptions = Array.prototype.slice.call(coozieDropdown.querySelectorAll('.img_dropdown__option'));
    selectOption(coozieDropdown, pick(coozieOptions));
  }

  function initCoozie3PackPicker(picker) {
    picker.querySelectorAll('[data-variant-index]').forEach(function (dropdown) {
      var options = Array.prototype.slice.call(dropdown.querySelectorAll('.img_dropdown__option'));
      selectOption(dropdown, pick(options));
    });
  }

  function initPickers() {
    document.querySelectorAll('[data-addon-picker="gameday-bundle"]').forEach(function (picker) {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';
      initGamedayPicker(picker);
    });
    document.querySelectorAll('[data-addon-picker="coozie-3-pack"]').forEach(function (picker) {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';
      initCoozie3PackPicker(picker);
    });
  }

  function initAll() {
    initPickers();
    pruneOrphanMenus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });

  function closeAllMenus() {
    document.querySelectorAll('[data-img-menu]').forEach(function (menu) {
      menu.hidden = true;
      var dropdown = dropdownFor(menu);
      var toggle = dropdown && dropdown.querySelector('[data-img-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }
  window.addEventListener('resize', closeAllMenus);
  // The cart drawer scrolls vertically — without this, an open,
  // fixed-position menu would stay put on screen while its toggle
  // scrolls away underneath it.
  document.addEventListener(
    'scroll',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer')) closeAllMenus();
    },
    true
  );

  // The cart drawer's sliding panel (.drawer__inner) carries a CSS
  // transform for its slide animation, which makes it the containing
  // block for any `position: fixed` descendant (per spec) — so a
  // fixed-position menu inside it does NOT position relative to the
  // real viewport. Moving each menu out to be a direct child of
  // <cart-drawer> (a sibling of .drawer__inner, still inside the
  // drawer's own max-z-index stacking context — body itself sits behind
  // that stacking context, so appending there would hide the menu)
  // sidesteps the transform entirely. Dropdowns are matched to their
  // (now-detached) menu by a small generated id since DOM containment
  // no longer applies once the menu has moved.
  var ddCounter = 0;
  function ensureDropdownId(dropdown) {
    if (!dropdown.dataset.ddId) {
      dropdown.dataset.ddId = 'dd' + ddCounter++;
      dropdown.querySelector('[data-img-menu]').dataset.ddId = dropdown.dataset.ddId;
    }
  }
  function menuFor(dropdown) {
    return document.querySelector('[data-img-menu][data-dd-id="' + dropdown.dataset.ddId + '"]');
  }
  function dropdownFor(menu) {
    return document.querySelector('[data-img-dropdown][data-dd-id="' + menu.dataset.ddId + '"]');
  }
  function menuHost(fromEl) {
    return (fromEl && fromEl.closest && fromEl.closest('cart-drawer')) || document.body;
  }
  // Clean up menus (and closed addon modals — see below) left behind in
  // the host from a prior cart render.
  function pruneOrphanMenus() {
    document.querySelectorAll('cart-drawer, body').forEach(function (host) {
      Array.prototype.forEach.call(host.children, function (child) {
        if (child.matches && child.matches('[data-img-menu]') && !dropdownFor(child)) {
          child.remove();
        }
        if (child.matches && child.matches('[data-addon-modal]') && child.hidden) {
          var modalId = child.dataset.addonModalId;
          var stillExists = document.querySelector(
            '[data-addon-modal-trigger][data-addon-modal-id="' + modalId + '"]'
          );
          // A cart AJAX re-render redraws the addons list from scratch,
          // so a fresh in-place copy of this modal can appear in
          // .addon_item while this relocated (moved-to-host) copy from
          // an earlier open is left behind, hidden, still matching a
          // live trigger — the "trigger gone" check above alone never
          // catches that case. Once a fresher in-place copy exists this
          // one is stale dead weight; the next open just relocates the
          // fresh copy again.
          var freshCopy = document.querySelector(
            '.addon_item [data-addon-modal][data-addon-modal-id="' + modalId + '"]'
          );
          if (!stillExists || freshCopy) child.remove();
        }
      });
    });
  }

  // Open/close the image dropdown menus, and record a pick.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-img-toggle]');
    var option = e.target.closest('.img_dropdown__option');
    var clickedMenu = e.target.closest('[data-img-menu]');

    if (toggle) {
      var dropdown = toggle.closest('[data-img-dropdown]');
      ensureDropdownId(dropdown);
      var menu = menuFor(dropdown);
      var host = menuHost(toggle);
      if (menu.parentNode !== host) host.appendChild(menu);
      var opening = menu.hidden;
      closeAllMenus();
      menu.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        var rect = toggle.getBoundingClientRect();
        // Measure the real rendered size now that it's unhidden, rather
        // than guessing — the option count (3 vs 6) changes both.
        var menuRect = menu.getBoundingClientRect();
        var left = Math.min(rect.left, window.innerWidth - menuRect.width - 8);
        left = Math.max(8, left);
        var spaceBelow = window.innerHeight - rect.bottom;
        var top =
          spaceBelow < menuRect.height + 12 && rect.top > menuRect.height + 12
            ? rect.top - menuRect.height - 4
            : rect.bottom + 4;
        menu.style.left = left + 'px';
        menu.style.top = Math.max(8, top) + 'px';
      }
      return;
    }

    if (option) {
      var menuEl = option.closest('[data-img-menu]');
      var optionDropdown = dropdownFor(menuEl);
      selectOption(optionDropdown, option);
      menuEl.hidden = true;
      var optionToggle = optionDropdown.querySelector('[data-img-toggle]');
      if (optionToggle) optionToggle.setAttribute('aria-expanded', 'false');
      return;
    }

    if (!clickedMenu) {
      closeAllMenus();
    }
  });

  // Each addon card is a plain button (no direct add-to-cart) that opens
  // a single-product popup — image, title, price, variant picker if any,
  // and the real "add to order" submit. Same fixed-position-inside-a-
  // transformed-drawer problem as the dropdown menus above, so the modal
  // gets relocated to be a child of <cart-drawer> the same way.
  function openAddonModal(trigger) {
    var modalId = trigger.dataset.addonModalId;
    var modal = document.querySelector('[data-addon-modal][data-addon-modal-id="' + modalId + '"]');
    if (!modal) return;
    var host = menuHost(trigger);
    if (modal.parentNode !== host) host.appendChild(modal);
    closeAllMenus();
    closeAllAddonModals();
    modal.hidden = false;
  }

  function closeAllAddonModals() {
    document.querySelectorAll('[data-addon-modal]').forEach(function (modal) {
      modal.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var modalTrigger = e.target.closest('[data-addon-modal-trigger]');
    if (modalTrigger) {
      e.preventDefault();
      openAddonModal(modalTrigger);
      return;
    }
    if (e.target.closest('[data-addon-modal-close]')) {
      closeAllAddonModals();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllAddonModals();
  });

  // Auto-close the popup once "Add to Order" actually finishes. The
  // button already carries a loading spinner that product-form.js shows
  // for the duration of the AJAX add and hides again when it completes —
  // watching that same signal (rather than guessing with a fixed delay)
  // means the popup closes exactly when the add is done, success or not.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.addon_modal .quick-add__submit');
      if (!btn) return;
      var spinner = btn.querySelector('.loading-overlay__spinner');
      if (!spinner) return;

      var sawLoading = false;
      var observer = new MutationObserver(function () {
        var isLoading = !spinner.classList.contains('hidden');
        if (isLoading) {
          sawLoading = true;
        } else if (sawLoading) {
          closeAllAddonModals();
          observer.disconnect();
        }
      });
      observer.observe(spinner, { attributes: true, attributeFilter: ['class'] });
      // Safety net: if something prevents the spinner from ever toggling
      // (e.g. the request errors before product-form.js shows it), don't
      // leave the observer running forever.
      setTimeout(function () { observer.disconnect(); }, 8000);
    },
    true
  );

  // On "Add to cart", read whatever is currently selected in the
  // inline pickers (random defaults or the shopper's own picks)
  // and write it into the real add-to-cart form fields.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.cart_addons .quick-add__submit');
      if (!btn) return;
      var form = btn.closest('form');
      var addonItem = btn.closest('.addon_item, [data-addon-modal]');
      if (!form || !addonItem) return;

      var gamedayPicker = addonItem.querySelector('[data-addon-picker="gameday-bundle"]');
      if (gamedayPicker) {
        gamedayPicker.querySelectorAll('[data-prop-name]').forEach(function (dropdown) {
          var propName = dropdown.dataset.propName === 'Coozie' ? 'Coozie ' : dropdown.dataset.propName;
          var field = form.querySelector('[name="properties[' + propName + ']"]');
          if (field) field.value = dropdown.dataset.value || '';
        });
        return;
      }

      var coozie3Picker = addonItem.querySelector('[data-addon-picker="coozie-3-pack"]');
      if (coozie3Picker && btn.dataset.variantMap) {
        var titles = btn.dataset.variantMap.split('|');
        var ids = btn.dataset.variantIds.split(',');
        var dropdowns = Array.prototype.slice.call(
          coozie3Picker.querySelectorAll('[data-variant-index]')
        ).sort(function (a, b) {
          return Number(a.dataset.variantIndex) - Number(b.dataset.variantIndex);
        });
        var targetTitle = dropdowns.map(function (d) { return d.dataset.value; }).join(' / ');
        var idx = titles.indexOf(targetTitle);
        if (idx !== -1) {
          form.querySelector('[name="id"]').value = ids[idx];
        }
      }
    },
    true
  );
})();
